import RichTextHeadline from '../../shared/RichTextHeadline/RichTextHeadline';
import RichTextList from '../../shared/RichTextList/RichTextList';
import { cn } from 'utils/styles';
import { HeroTextSize } from 'components/HeroConsolidated/constants';
import { HeroConsolidatedProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';

type HeroContentProps = Pick<
  HeroConsolidatedProps,
  'sys' | 'headline' | 'copy' | 'headlineSize' | 'copySize' | 'headingLevel'
> & {
  copyClassName?: string;
};

const HeroContent = ({
  headline,
  copy,
  sys,
  headlineSize,
  copySize,
  headingLevel,
  copyClassName,
}: HeroContentProps) => {
  return (
    <div className="flex-col">
      <div
        className={cn('text-heading-md md:text-heading-xl font-semibold font-sans mb-4', {
          'md:text-heading-xxxl mb-8': headlineSize === HeroTextSize.Large,
        })}
        {...liveUpdateAttrs(sys?.id, 'headline')}>
        {headline && <RichTextHeadline headline={headline} level={headingLevel || 'h1'} />}
      </div>
      {copy && (
        <div
          className={cn(
            'hero-copy font-serif text-body-serif flex flex-col gap-4',
            { 'font-sans text-heading-sm': copySize === HeroTextSize.Large },
            copyClassName,
          )}
          {...liveUpdateAttrs(sys?.id, 'copy')}>
          <RichTextList item={copy} />
        </div>
      )}
    </div>
  );
};

export default HeroContent;
